import axios from '@/utils'



// 自定义配置
export function config_data (params) {
    return axios({
        method: 'get',
        url: '/client/config_data',
        params
    })
}

// 权益列表
export function yushou_rights_list (params) {
    return axios({
        method: 'get',
        url: '/yushou/rights/list',
        params
    })
}

// 兑换in
export function exchange_in (params) {
    return axios({
        method: 'get',
        url: '/yushou/in/exchange',
        params
    })
}

// 兑换实体御守
export function exchange (data) {
    return axios({
        method: 'post',
        url: '/yushou/nft/exchange',
        data
    })
}

// 我的地址列表
export function address_list (params) {
    return axios({
        method: 'get',
        url: '/address/lists',
        params
    })
}

// 删除地址
export function delete_address (data) {
    return axios({
        method: 'post',
        url: '/address/delete',
        data
    })
}

// 更新地址
export function updata_address (data) {
    return axios({
        method: 'post',
        url: '/address/update',
        data
    })
}

// 添加地址
export function add_address (data) {
    return axios({
        method: 'post',
        url: '/address/add',
        data
    })
}

// 获取二维码
export function qrcode (data) {
    return axios({
        method: 'post',
        url: '/rights/qrcode',
        data
    })
}

// 获取二维码
export function avatarExchange (data) {
    return axios({
        method: 'post',
        url: '/nftRights/avatarExchange',
        data
    })
}